export default {
  title: 'シーン',
  playTitle: 'ゲームプレイテンプレート',
  deleteSceneConfirm: 'このシーンを削除しますか？',
  deletePlaySceneConfirm: {
    title: 'ゲームテンプレートを削除しますか？',
    rule1:
      '- ゲームテンプレートを削除すると、ゲームテンプレートにバインドされているシーンも一緒に削除されます。シーンの内容を保持する場合は、先にシーンとゲームテンプレートのバインドを解除してから削除してください。',
    rule2: '- この操作は元に戻せません。本当に削除しますか？',
    rule3:
      '- 最後のプレイ方法テンプレートを削除すると、自動的にプロジェクト編集ページに戻ります。',
  },
  deleteSceneWarning: '警告',
  confirm: '確定',
  cancel: 'キャンセル',
  newScene: '新しいシーンを作成',
  copyScene: 'シーンをコピー',
  renameScene: '名前の変更',
  deleteScene: 'シーンを削除',
  newAndSave: 'プリセットとして保存',
  saveSuccess: 'シーンの作成に成功しました',
  deleteSceneError: '少なくとも1つのシーンが必要です',
  newPlayScene: '新しいプレイシーンを作成',
  deletePlayScene: 'プレイシーンを削除',
}
